export default class RequestIT2104RequestDTO {

    public employeeId: number | null = null;
    public employerId: number | null = null;
    public sublimeFilling = false;

}
